/**
 * API Configuration
 * Configuración centralizada para las URLs del backend
 */

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  TIMEOUT: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000'),
  /** Subida JD: backend puede tardar hasta ~120s en Gemini + GCS/Firestore; el cliente debe esperar más que eso. */
  UPLOAD_JD_TIMEOUT_MS: parseInt(import.meta.env.VITE_UPLOAD_JD_TIMEOUT_MS || '180000'),

  ENDPOINTS: {
    // Vacantes (Recruiter)
    VACANTES: {
      UPLOAD_JD: '/api/vacantes/upload-jd',
      GET_VACANTE: (id: string) => `/api/vacantes/${id}`,
      UPDATE_VACANTE: (id: string) => `/api/vacantes/${id}`,
      DELETE_VACANTE: (id: string) => `/api/vacantes/${id}`,
      LIST_VACANTES: '/api/vacantes',
      UPDATE_STATUS: (id: string) => `/api/vacantes/${id}/status`,
      PUBLISH_VACANTE: (id: string) => `/api/vacantes/${id}/publicar`,
      GET_PUBLIC_VACANTE: (id: string) => `/api/vacantes/publico/${id}`,
      GET_CANDIDATE_CV_DATA: (vacanteId: string, candidateUid: string) =>
        `/api/vacantes/${vacanteId}/candidatos/${candidateUid}/cv-data`,
      UPDATE_CANDIDATE_CV_DATA: (vacanteId: string, candidateUid: string) =>
        `/api/vacantes/${vacanteId}/candidatos/${candidateUid}/cv-data`,
    },

    // Autenticación
    AUTH: {
      CANDIDATE_TOKEN: '/tokens/google',
      VERIFY_TOKEN: '/api/auth/verify',
      REFRESH_TOKEN: '/api/auth/refresh',
      GOOGLE_CALENDAR_LOGIN: '/api/auth/google/calendar/login',
      GOOGLE_CALENDAR_CALLBACK: '/api/auth/google/calendar/callback',
    },

    // Aplicaciones de Candidatos
    APLICACIONES: {
      CV_UPLOAD_URL: '/api/aplicaciones/cv/upload-url',
      CV_CONFIRM_UPLOAD: '/api/aplicaciones/cv/confirm-upload',
      CV_UPDATE_INFO: '/api/aplicaciones/cv/update-info',
      CV_EXTRACTED_DATA: '/api/aplicaciones/cv/extracted-data',
      VIDEO_UPLOAD_URL: '/api/aplicaciones/video/upload-url',
      VIDEO_CONFIRM_UPLOAD: '/api/aplicaciones/video/confirm-upload',
      GET_APPLICATION_STATUS: (jobId: string) => `/api/aplicaciones/status/${jobId}`,
      CHECK_COMPLETION: (jobId: string) => `/api/aplicaciones/check-completion/${jobId}`,
    },

    // IA - Generación de Preguntas
    IA: {
      GENERATE_QUESTIONS: (jobId: string) => `/api/ia/candidatos/${jobId}/preguntas`,
      LIST_AVAILABLE_VACANTES: '/api/ia/vacantes/disponibles',
      SUBMIT_ANSWERS: '/api/ia/answers',
    },

    // Calendar (si existe)
    CALENDAR: {
      SCHEDULE: '/api/calendar/schedule',
      AVAILABILITY: '/api/calendar/availability',
    }
  }
} as const;

export default API_CONFIG;
